import MeetDoctors from "./MeetDoctors";
import HoverCadHomeSpecialist from "./HoverCadHomeSpecialist";
import MinimalCardHomeSpecialist from "./MinimalCardHomeSpecialist";
import OverlayRevealHomeSpecialist from "./OverlayRevealHomeSpecialist";
import { useSelector } from "react-redux";
import DropDownCtaDoctors from "./DropDownCtaDoctors";

function MeetOurSpecialiistsWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <div>
      {sitedata?.theme_specialist === "hover-card" ? (
        <HoverCadHomeSpecialist />
      ) : sitedata?.theme_specialist === "minimal-grid" ? (
        <MinimalCardHomeSpecialist />
      ) : sitedata?.theme_specialist === "dropdown-cta" ? (
        <DropDownCtaDoctors />
      ) : sitedata?.theme_specialist === "overlay-reveal" ? (
        <OverlayRevealHomeSpecialist />
      ) : (
        <MeetDoctors />
      )}
      {/* <MinimalCardHomeSpecialist /> */}

    </div>
  );
}

export default MeetOurSpecialiistsWrapper;
